import React, { Fragment, useEffect, useRef, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import secureLocalStorage from "react-secure-storage";
import jsPDF from "jspdf";
import { X } from "lucide-react"; 

//components
import apiService from "../APIService";
import Conversation from "../Conversation/MessageCodes/Conversation";
import {
  sendOnAppClose,
  sendOnAppOpen,
} from "../../Simplify360Chat/Services/HWIframeBridge";
import { Constants } from "../../Constants/Constants";
import ToastMessage from "../Conversation/Utils/Toast/ToastMessage";

//images
import sendIcon from "../../images/icons/send.svg";
import sendIconGrey from "../../images/icons/send-gray.svg";
import User from "../../images/oriserve/images/user.png";
import Buddy from "../../images/oriserve/images/buddy.png";
import closeIcon from  "../../images/oriserve/images/closeIcon.svg"
import menuIcon from "../../images/oriserve/images/menuIcon.svg"
import isAttachementDisable from "../../images/oriserve/images/attachmentDisable.svg"
import isDefaultAttachement from "../../images/oriserve/images/attachment.svg"
import isBlinkAttachement from "../../images/oriserve/images/attachmentBlink.svg"
import sendButton from "../../images/oriserve/images/SendButton.svg"
import BuddyIcon from "../../images/oriserve/images/buddyIcon.svg";
import AlertIcon from "../../images/oriserve/images/alert.svg";
import languageIcon from "../../images/oriserve/images/languageIcon.svg";



//css
import "./HelpAssistant.css";
import "../CoachScreen.css";
import "../css/gethelp-responsive.css";
import UploadFile from "../FormFields/UploadFile";

const LANGUAGES = ["English", "Hindi", "Marathi", "Gujarati", "Kannada", "Telugu"];

const HelpAssistant = (props) => {
  const [onClickYes, setOnClickYes] = useState(false);
  const [typedFlag, setTypedFlag] = useState("");
  const [showClose, setShowClose] = useState(false);
  const [showMinimize, setShowMinimize] = useState(false);
  const [conversation, setConversation] = useState(false);
  const [showAssistantToolTip, setShowAssistantToolTip] = useState(false);
  const [showChatToolTip, setShowChatToolTip] = useState(false);
  const [feedbackUrl, setFeedBackUrl] = useState(null);
  const [historyData, setHistoryData] = useState();
  const [changedRefresh, setChangedRefresh] = useState(false);
  const [showSecondOk, setShowSecondOk] = useState(false);
  const [thirdOkay, setThirdOkay] = useState(false);
  const [sth, setSth] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [historyLoader, setHistoryLoader] = useState(false);
  const [loginLoader, setLoginLoader] = useState(true);
  const [name, setName] = useState();
  const [login, setLogin] = useState(false);
  const [enableDefaultTextBox, setEnableDefaultTextBox] = useState(false);
  const [auth, setAuth] = useState(props.authenticated);
  const [textMessage, setTextMessage] = useState("");
  const [backToMenuRender, setBackToMenuRender] = useState(false);
  const [minimized, setMinimized] = useState(
    props.launchOnButton !== undefined && props.launchOnButton ? false : true
  );
  const [showVersion, setShowVersion] = useState(false);
  const [showFeedBackIframe, setShowFeedBackIframe] = useState(false);
  const [maximized, setMaximized] = useState(true);
  const [outSideLink, setOutSideLink] = useState(true);
  const [overlayVisible, setOverlayVisible] = useState(true);
  const [tempLinkDetails, setTempLinkDetails] = useState(null);
  const [actionFromConfig, setActionFromConfig] = useState(null);
  const [chatData, setChatData] = useState([]);
  const [showOverlay, setshowOverlay] = useState(false);
  const [currentData, setCurrentData] = useState([]);
  const [loggedInTillrefresh, setLoggedInTillrefresh] = useState(false);
  const [agentScreen, setAgentScreen] = useState(false);
  const [agentInfo, setAgentInfo] = useState(null);
  const [agentHeader, setAgentHeader] = useState(false);
  const [chatClosed, setChatClosed] = useState(false);
  const messageRef = useRef(null);
  const [agentUserData, setAgentUserData] = useState(null);
  const [genesysWindowUpdate, setgenesysWindowUpdate] = useState(null);
  const [toast, setToast] = useState(false);
  const [interactionId, setIntereactionId] = useState("");
  const [mergeUI, setMergeUI] = useState(false);

  const [showClearChat, setIsClearChatModal] = useState(false);

  const [showOnlineUI, setShowOnlineUI] = useState(true);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const [selectedLanguage, setSelectedLanguage] = useState(
    () => localStorage.getItem("selectedLanguage") || ""
  );
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, right: 0 });
  const languageMenuRef = useRef(null);

  useEffect(() => {
    if (!showLanguageDropdown) return;
    const handleOutsideClick = (event) => {
      if (
        languageMenuRef.current &&
        !languageMenuRef.current.contains(event.target)
      ) {
        setShowLanguageDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () =>
      document.removeEventListener("mousedown", handleOutsideClick);
  }, [showLanguageDropdown]);

  const [hideFooter, setHideFooter] = useState(false);

  const [isSessionExpired, setIsSessionExpired] = useState(false);

  const [showIdlePopup, setShowIdlePopup] = useState(false);

  const [isChatWithUs, setIsChatWithUs] = useState(false);

  const [delayBotResponse, setDelayBotResponse] = useState(false);

  const [disabledEntryIcons, setDisabledEntryIcons] = useState(false);

  const [onMenuButtonClick , setOnMenuButtonClick] = useState(false)
  const [isFullScreen, setIsFullScreen] = useState({show : false, src:''});
  const [showErrorPopUp , setShowErrorPopUp] = useState(false)
  const [enableAttachment , setEnableAttachment] = useState(false)
  const [attachementImg , setAttachementImg] = useState(isAttachementDisable)
  const [flow ,setFlow] = useState("")
  const [CTAView ,setCTAView] = useState("")
  const [codeValue ,setCodeValue] = useState("") // For API call
  const [validationType, setValidationType] = useState("") // For validation type
  const [validationError, setValidationError] = useState("");
  const [enableA14sValidation, setEnableA14sValidation] = useState(false);
  const [showValidationPopup, setShowValidationPopup] = useState(false);
  const [blinking, setBlinking] = useState(false);
  const [genesisUrl,setGenesisUrl] =useState(null)

  const [litmusFeedback , setLitmusFeedback] = useState(null)

 
 

  const iframeRef = useRef(null);
  const [showIframe, setShowIframe] = useState(false);
  const [delayTime,setDelayTime] =useState(null)
  const [showIdleMsg,setShowIdleMsg] = useState(false)
  

 
  const [showFeedback, setShowFeedback] = useState(false);

  const [sessionHistory, setSessionHistory] = useState(false);  

  useEffect(() => {
    if (litmusFeedback) {
      const start = Date.now();
  
      const startDate = new Date(start);
      const startFormatted = `${String(startDate.getHours()).padStart(2, "0")}:${String(
        startDate.getMinutes()
      ).padStart(2, "0")}:${String(startDate.getSeconds()).padStart(
        2,
        "0"
      )}.${String(startDate.getMilliseconds()).padStart(3, "0")}`;
  
      console.log(`Litmus Timer started[${startFormatted}] `);
  
      const timer = setTimeout(() => {
        setShowFeedback(true);
  
        const end = Date.now();
        const endDate = new Date(end);
        const endFormatted = `${String(endDate.getHours()).padStart(2, "0")}:${String(
          endDate.getMinutes()
        ).padStart(2, "0")}:${String(endDate.getSeconds()).padStart(
          2,
          "0"
        )}.${String(endDate.getMilliseconds()).padStart(3, "0")}`;
  
        console.log(`Litmus Timer ended [${endFormatted}] `);
        console.log(`Litmus Time Elapsed: ${end - start} ms`);
      }, 500);
  
      return () => clearTimeout(timer);
    } else {
      setShowFeedback(false);
    }
  }, [litmusFeedback]);
  
  


  

  var tempAgentData = null;
  const myRef = useRef(null);
  const uploadRef = useRef(null);






  useEffect(() => {
    console.log("litmusFeedback changed:", litmusFeedback);
  
    let timerId;
  
    if (litmusFeedback) {
      timerId = setTimeout(() => {
        console.log("⏱️ 60s passed. Sending postMessage.");
        try {
          window.top.postMessage({ endChatURLFeedback: "true" }, "*");
        } catch (e) {
          console.warn("Unable to go back:", e);
        }
      }, 60000);
    }
  
    // Cleanup the timer if litmusFeedback changes or component unmounts
    return () => {
      clearTimeout(timerId);
    };
  }, [litmusFeedback]);
  
  
  
  

  useEffect(() => {
    localStorage.removeItem("inputValue");
    sessionStorage.removeItem("showIdleTime");
    sessionStorage.removeItem('showNumberHint');
    let showFirstUIFor100ms = () => {
      setTimeout(() => {
        setShowOnlineUI(false);
      }, 500);
    };

    showFirstUIFor100ms();

    return () => {
      clearTimeout(showFirstUIFor100ms);
    };
  }, []);

  useEffect(()=>{
    const popup = document.querySelector(".error-popup");

    if (!popup) {
      console.error("Error: .error-popup element not found!");
      return;
    }
    popup.classList.remove("hide"); // Remove hide class if present
    popup.classList.add("show");
  


    setTimeout(() => {
   
      popup.classList.remove("show");
      popup.classList.add("hide");
    
    setShowErrorPopUp(false)
    }, 5000);
  },[showErrorPopUp])







  useEffect(() => {
    if (enableAttachment) {
      setBlinking(true); // Start blinking
      setAttachementImg(isDefaultAttachement)
   
      const timeout = setTimeout(() => {
        setBlinking(false); // Stop blinking after 5 seconds
       
      }, 2000);
    }
  }, [enableAttachment]);

  //handleTabClosure event
  useEffect(() => {
    const handleTabClosure = () => {
      apiService.userActivity("4").then((res) => {
        console.log(res);
      });
    };

    window.addEventListener("beforeunload", handleTabClosure);

    setDisabledEntryIcons(false)

    return () => {
      window.removeEventListener("beforeunload", handleTabClosure);
    };
  }, []);

  //handleBackButton event
  useEffect(() => {
    const handleBackButton = () => {
      apiService.userActivity("4").then((res) => {
        console.log(res);
      });
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem("s360ChatLoggedIn", "false");
    sessionStorage.removeItem('showNumberHint');
    setshowOverlay(false);
    return () => {
      localStorage.removeItem("lastHdValue");
      localStorage.setItem("intereactionId", null);
    };
  }, []);

  useEffect(() => {
    if (!minimized) {
      startLogin();
      setOnClickYes(false);
      localStorage.setItem("onClickedYes", false);
    }
  }, [minimized]);

  useEffect(() => {
    setAuth(props.authenticated);
  }, [props.authenticated]);

  useEffect(() => {
    linkDetection(window.location.href);
    setConversation(true);
    if (props.launchOnButton || window.location.href.includes("action")) {
      if (
        window.location.href.includes("action") &&
        localStorage.getItem("linkChatOnce") === null &&
        localStorage.getItem("linkLoginOnce") === null
      ) {
        sendNewOutsideLinkApi();
      } else if (
        props.action &&
        !window.location.href.includes("action") &&
        localStorage.getItem("linkChatOnce") === null &&
        localStorage.getItem("linkLoginOnce") === null
      ) {
        sendOutsideLinkApi();
      }
    }
  }, []);

  useEffect(() => {
    setThirdOkay(false);
  }, [typedFlag]);

  const handleClearModal = () => {
    setIsClearChatModal(true);
  };

  const extractFromUrl = (url) => {
    var splitArray = [];
    const queryParams = new URLSearchParams(url);
    for (const [key, value] of queryParams) {
      splitArray.push({ key, value });
    }
    var ExtractedUrlTemp = splitArray.reduce(
      (a, item) => Object.assign(a, { [item.key]: item.value }),
      {}
    );

    let extractedURl = new Object();
    extractedURl.authenticated = ExtractedUrlTemp.authenticated || false;
    extractedURl.subscriberId = ExtractedUrlTemp.subId;
    extractedURl.action = ExtractedUrlTemp.action || "1";
    extractedURl.src = ExtractedUrlTemp.src || "Deep Link";
    if (
      extractedURl.action != undefined &&
      (extractedURl.authenticated != undefined ||
        extractedURl.subId != undefined)
    ) {
      setTempLinkDetails(extractedURl);
      return extractedURl;
    } else {
      return false;
    }
  };

  const setInteractionIdFunction = (interactionIdRecieved) => {
    setIntereactionId(interactionId);
  };

  const setAgentScreenFunction = (agentStatus) => {
    if (agentStatus !== undefined) {
      setAgentScreen(agentStatus.agentScreen);
      setAgentInfo(agentStatus);
    }
    setgenesysWindowUpdate(agentStatus.refresher);
  };

  const linkDetection = (url) => {
    if (url.includes("action")) {
      setOutSideLink(true);
      setshowOverlay(false);
      sendOnAppOpen();

      setShowClose(false);
      setShowMinimize(false);
      setMinimized(false);
      extractFromUrl(url);
    } else {
      if (props.action !== undefined && props.action !== null) {
        setActionFromConfig(props.action);
        if (props.hideLoading) {
          setOutSideLink(false);
        } else {
          setOutSideLink(false);
          setOverlayVisible(false);
        }
        actionInConfig(props);
      } else {
        if (props.hideLoading) {
          setshowOverlay(false);
          sendOnAppOpen();
          setShowClose(false);
          setShowMinimize(false);
          setMinimized(false);
        }
        setOutSideLink(false);
        setOverlayVisible(false);
      }
    }
  };

  const actionInConfig = (props) => {
    if (props?.action !== undefined || props?.action !== null) {
      if (props.hideLoading) {
        setOutSideLink(true);
        setshowOverlay(false);
        sendOnAppOpen();
        setShowClose(false);
        setShowMinimize(false);
        setMinimized(false);
      }
    }
  };

  const sendOutsideLinkApi = () => {
    setLoggedInTillrefresh(true);

    if (props?.userDetails) {
      apiService.loginForLink(props?.userDetails).then((response) => {
        chatReopenFunction(response.data.token, changedRefresh);
        sessionStorage.setItem("token", response.data.token);
        if (response.data.userInfo !== undefined) {
          localStorage.setItem(
            "userName",
            JSON.stringify(response?.data?.userInfo?.customerName)
          );
        } else {
          localStorage.setItem("userName", JSON.stringify("Testing"));
        }

        setLogin(true);

        if (!auth) {
          setLoginLoader(false);
          setLogin(true);
        }
      });
    } else {
      console.log("sendOutsideLinkApi", props.userDetails);
    }
  };

  const sendNewOutsideLinkApi = () => {
    setChangedRefresh(false);

    if (props?.userDetails) {
      apiService.loginForLink(props?.userDetails).then((response) => {
        chatReopenFunction(response.data.token, changedRefresh);
        sessionStorage.setItem("token", response.data.token);

        if (response.data.userInfo !== undefined) {
          localStorage.setItem(
            "userName",
            JSON.stringify(response?.data?.userInfo?.customerName)
          );
        } else {
          localStorage.setItem("userName", JSON.stringify("Testing"));
        }

        setLogin(true);

        if (!auth) {
          setLoginLoader(false);
          setLogin(true);
        }
      });
    } else {
      console.log("sendNewOutsideLinkApi", props.userDetails);
    }
  };

  //prod-remove
  // const generatePDF = (conversations) => {
  //   const doc = new jsPDF();
  //   let y = 10; // initial y position
  //   const marginBottom = 20; // bottom margin

  //   conversations.forEach((chat) => {
  //     if (!chat) return; // Ensure chat is not null or undefined

  //     doc.text(10, y, `Time: ${chat.time}`);
  //     y += 10;

  //     let isFirstBotMessage = true;

  //     chat.botResponse.entries.forEach((entry) => {
  //       if (!entry) return; // Ensure entry is not null or undefined

  //       const textToAdd = isFirstBotMessage ? `Bot: ${entry.text}` : entry.text;
  //       const splitText = doc.splitTextToSize(textToAdd, 180);

  //       if (
  //         y + splitText.length * 10 >
  //         doc.internal.pageSize.height - marginBottom
  //       ) {
  //         doc.addPage();
  //         y = 10;
  //       }

  //       doc.text(10, y, splitText);
  //       if (isFirstBotMessage) isFirstBotMessage = false;
  //       y += splitText.length * 10;
  //     });

  //     if (chat.userResponse) {
  //       const userResponseText = `User: ${chat.userResponse.text}`;
  //       const splitUserResponse = doc.splitTextToSize(userResponseText, 180);

  //       if (
  //         y + splitUserResponse.length * 10 >
  //         doc.internal.pageSize.height - marginBottom
  //       ) {
  //         doc.addPage();
  //         y = 10;
  //       }

  //       doc.text(10, y, splitUserResponse);
  //       y += splitUserResponse.length * 10;
  //     }

  //     y += 10; // add some space before the next chat block
  //   });

  //   return doc.output("blob");
  // };


  //prod-remove
  // const handleUploadSuccess = (
  //   response,
  //   props,
  //   chatReopenFunction,
  //   backToMenuFunction,
  //   setLogin,
  //   setLoginLoader
  // ) => {
  //   if (response?.data?.code === 200) {
  //     const userDetails = props?.userDetails;
  //     if (!userDetails) return;

  //     apiService
  //       .loginForLink(userDetails)
  //       .then((loginResponse) => {
  //         if (!loginResponse?.data) return;

  //         chatReopenFunction(loginResponse.data.token, changedRefresh);
  //         sessionStorage.setItem("token", loginResponse.data.token);

  //         backToMenuFunction();

  //         const userName =
  //           loginResponse.data.userInfo?.customerName || "Testing";
  //         localStorage.setItem("userName", JSON.stringify(userName));

  //         setLogin(true);
  //         if (!auth) setLoginLoader(false);
  //       })
  //       .catch((err) => {
  //         console.error("Login failed:", err);
  //       });
  //   }
  // };

  const clearChat = () => {
    apiService
      .userActivity("2")
      .then((res) => {
        const { code, sessionId } = res.data;
        if (code !== 200 || !sessionId) return;

        //prod-resume
        // apiService
        //   .getConversationDetails(sessionId)
        //   .then((res) => {
        //     if (!res?.data?.data) return;

        //     const pdfBlob = generatePDF(res.data.data);

        //     const formData = new FormData();
        //     formData.append("file", pdfBlob, "conversation.pdf");
        //     formData.append("sessionId", sessionId);
        //     formData.append("bot", "oriserve");

        //     console.log(formData);

        //     apiService
        //       .uploadConversationMedia(formData, sessionId)
        //       .then((uploadRes) => {
        //         handleUploadSuccess(
        //           uploadRes,
        //           props,
        //           chatReopenFunction,
        //           backToMenuFunction,
        //           setLogin,
        //           setLoginLoader
        //         );
        //       })
        //       .catch((err) => {
        //         console.error("File upload failed:", err);
        //         backToMenuFunction();
        //       });
        //   })
        //   .catch((err) => {
        //     console.error("Failed to get conversation details:", err);
        //   });
      })
      .catch((err) => {
        console.error("User activity failed:", err);
      });

    setTextMessage({
      key1: "",
      count: Math.random(),
    });

    if (props?.userDetails) {
      apiService.loginForLink(props?.userDetails).then((response) => {
        chatReopenFunction(response.data.token, changedRefresh);
        sessionStorage.setItem("token", response.data.token);
        backToMenuFunction();
        if (response.data.userInfo !== undefined) {
          localStorage.setItem(
            "userName",
            JSON.stringify(response?.data?.userInfo?.customerName)
          );
        } else {
          localStorage.setItem("userName", JSON.stringify("Testing"));
        }
        setLogin(true);
        if (!auth) {
          setLoginLoader(false);
          setLogin(true);
        }
      });
    }
  };

  const backToMenuFunction = () => {
    setShowClose(false);
    setIsClearChatModal(false);
    setShowIdlePopup(false);
    setBackToMenuRender(!backToMenuRender);
    setHideFooter(false);
    restartChatOnBackToMenu(sessionStorage.getItem("token"));
  };

  const minimizeChat = () => {
    localStorage.setItem("jumpNode", true);
    window.parent.postMessage(
      {
        closeChat: "true",
      },
      "*" //or "www.parentpage.com"
    );
  };

  const handleHistory = () => {
    setHistoryLoader(true);
    apiService
      .historyApi(props.sessionId, props.source)
      .then((response) => {
        setHistoryLoader(false);
        setHistoryData(response.data);
        setShowHistory(true);
      })
      .catch((error) => {
        setHistoryLoader(false);
      });
  };

  useEffect(() => {
    if (props.viewType === "history") {
      handleHistory();

      setSth(true);
    }
  }, []);

  useEffect(() => {
    if (!agentScreen) {
      setAgentHeader(false);
    }
    if (agentScreen) {
      setAgentHeader(true);
    }
  }, [genesysWindowUpdate]);

  useEffect(() => {
    let El = document.getElementById("s360ChatSectionContainer");

    if (agentScreen) {
      if (El) El.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [genesysWindowUpdate]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onMessageSend();
    }
  };

  const addToastMessage = () => {
    setToast(true);
  };

  const onMessageSend = () => {
    let hasTextMessage = messageRef.current.value.trim();
    const validationType = getValidationType();

    if (hasTextMessage === "") {
      addToastMessage();
      return;
    }

    if (validationType === 'number' && sessionStorage.getItem('showNumberHint') === 'true' && !validateInput(hasTextMessage, true)) {
      setValidationError(getErrorMessage());
      setShowValidationPopup(true);
      setTimeout(() => setShowValidationPopup(false), 3000);
      return;
    }

    if (validationError) {
      addToastMessage();
      return;
    }

    setToast(false);
    setTextMessage({
      key1: hasTextMessage,
      count: Math.random(),
    });

    messageRef.current.value = "";
    setTypedFlag("");
    setValidationError("");
    setShowValidationPopup(false);
  };

  const startLogin = () => {
    sendNewOutsideLinkApi();
  };

  const getValidationType = () => {
    if (!enableA14sValidation) return null;
    if (!validationType || validationType === "") return null;
    
    try {
      if (typeof validationType === 'string' && validationType.length > 0) {
        return validationType.toLowerCase();
      }
      
      const parsed = JSON.parse(validationType);
      return parsed?.type?.toLowerCase() || null;
    } catch (e) {
      return null;
    }
  };

  const validateInput = (value, checkLength = false) => {
    const validationType = getValidationType();
    if (!validationType) return true;

    switch (validationType) {
      case 'number':
        if (!/^[0-9]*$/.test(value)) return false;
        if (checkLength && value.length > 0 && value.length !== 10) return false;
        return true;
      case 'email':
        return /^[a-zA-Z0-9\s@.,]*$/.test(value) && !value.startsWith(".") && !value.startsWith(",");
      case 'text':
        return /^[a-zA-Z\s]*$/.test(value);
      case 'alphanumeric':
        return /^[a-zA-Z0-9\s]*$/.test(value);
      default:
        return true;
    }
  };

  const getErrorMessage = () => {
    const validationType = getValidationType();
    const value = messageRef.current?.value || "";
    
    switch (validationType) {
      case 'number':
        if (!/^[0-9]*$/.test(value)) return "Only numbers are allowed";
        if (value.length > 0 && value.length < 10) return "Phone number must be 10 digits";
        if (value.length > 10) return "Phone number cannot exceed 10 digits";
        return "Only numbers are allowed";
      case 'email':
        return "Invalid email format";
      case 'text':
        return "Only letters are allowed";
      case 'alphanumeric':
        return "Only letters and numbers are allowed";
      default:
        return "";
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const validationType = getValidationType();
    
    if (validationType === 'number' && value.length > 10) {
      return;
    }
    
    setTypedFlag(value);
    
    if (enableA14sValidation && validationType !== 'number' && sessionStorage.getItem('showNumberHint') === 'true' && !validateInput(value)) {
      setValidationError(getErrorMessage());
      setShowValidationPopup(true);
      setTimeout(() => setShowValidationPopup(false), 3000);
    } else {
      setValidationError("");
      setShowValidationPopup(false);
    }
    
    if (document.getElementById("tx").scrollHeight > 50) {
      document.getElementById("tx").style.overflowY = "scroll";
    }
  };

  const handleInputBox = (value) => {
    //change true /false for UAT PROD --->enable textbox
    if (value === undefined || value === null || value === false) {
      setEnableDefaultTextBox(false);
    } else {
      setEnableDefaultTextBox(true);
    }
  };
  const setUserDataForAgent = (data) => {
    if (tempAgentData === null) {
      tempAgentData = data;
    }
    setAgentUserData(data);
  };

  const restartChatOnBackToMenu = (tokenData) => {
    setLoginLoader(true);
    apiService.chatForLink(tokenData, false).then((response) => {
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;
      if (response?.data?.chatResponse?.mergeUI) {
        setMergeUI(true);
      }
      if (data) {
        setChatData(data);
      }
      handleInputBox(response?.data?.chatResponse?.enableDefaultTextBox);
      setLoginLoader(false);
    });
  };

  const chatReopenFunction = (tokenData) => {
    sessionStorage.setItem("token", tokenData);
    setLoginLoader(true);
    setTimeout(() => {
      
   
    apiService.chatForLink(tokenData, changedRefresh).then((response) => {
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;
        setFlow(response?.data?.chatResponse?.flow)
        setCTAView(response?.data?.chatResponse?.enableVertical)
      // data.push({
      //   uiCommand: "time",
      //   text:
      //     new Date().toLocaleTimeString("en-us").split(":")[0] +
      //     ":" +
      //     new Date().toLocaleTimeString("en-us").split(":")[1] +
      //     " " +
      //     new Date().toLocaleTimeString("en-us").substr(-2),
      // });

      // if (data && data.some((el) => el?.uiCommand === "A1")) {
      //   setHideFooter(true);
      // }

      setChatData(data);
      // handleInputBox(response?.data?.chatResponse?.enableDefaultTextBox);
      setLoginLoader(false);
      if (response?.data?.chatResponse?.mergeUI) {
        setMergeUI(true);
      }
    });
  }, 1000);
  };

  const handleThirdOkay = () => {
    setThirdOkay(false);
  };

  const handleEndChat = () => {
    setShowClose(true);
  };

  const fetchUserActivity = async () => {
    try {
      const res = await apiService.userActivity("1");
      const { code, sessionId } = res.data;
      if (code !== 200 || !sessionId) throw new Error("Invalid response");
      return sessionId;
    } catch (error) {
      console.error("fetchUserActivity error:", error);
    }
  };

  const fetchConversationDetails = async (sessionId) => {
    try {
      const res = await apiService.getConversationDetails(sessionId);
      return res.data.data;
    } catch (error) {
      console.error("fetchConversationDetails error:", error);
    }
  };

  const uploadConversationPDF = async (sessionId, pdfBlob) => {
    try {
      const formData = new FormData();
      formData.append("file", pdfBlob, "conversation.pdf");
      formData.append("sessionId", sessionId);
      formData.append("bot", "oriserve");

      const response = await apiService.uploadConversationMedia(
        formData,
        sessionId
      );
      if (response.data.code !== 200) throw new Error("File upload failed");
      return response.data;
    } catch (error) {
      console.error("uploadConversationPDF error:", error);
    }
  };

  const handleConfirm = async () => {
    try {
      const sessionId = await fetchUserActivity();
      // const conversationDetails = await fetchConversationDetails(sessionId);
      // const pdfBlob = generatePDF(conversationDetails);
      // await uploadConversationPDF(sessionId, pdfBlob);
      setShowClose(false);
      backToMenuFunction();
      window.parent.postMessage({ endChatURL: "true" }, "*");
    } catch (error) {
      console.error("handleConfirm error:", error);
    }
  };


  //Handle exit full screen
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsFullScreen((prevState) => ({ ...prevState, show: false }));
      }
    };
  
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Fragment>
      <>
        {!minimized && (
          <div
            className="help-chat-box chatIn-header help-assistantwrapp hbc0 maximize chat-box-animation "
            style={{ visibility: maximized ? "visible" : "hidden" }}
            id="top"
            key={!backToMenuRender}
          >

            {showClose && (
              <>
                <div className="chat-blkoverlay" style={{ display: "block" }}>
                  <div
                    className="confirmContr"
                    style={{ zIndex: 999999999999999 }}
                  >
                    <div className="user-img">
                      <img
                        style={{ width: "55px", height: "55px" }}
                        src={User}
                        alt="user"
                      />
                    </div>
                    <div>
                      <img
                        style={{ width: "103px", height: "30px" }}
                        src={Buddy}
                        alt="user"
                      />
                    </div>
                    <div className="close-wrap">
                      <p
                        style={{
                          paddingLeft: "10%",
                          paddingRight: "10%",
                          fontSize: 14,
                        }}
                        className="volte-text"
                      >
                        {" "}
                        Do you want to close this session?
                      </p>
                      <div className="btn-contr mT20">
                        <button
                          style={{
                            border: "1px solid #E1009D",
                            cursor: "pointer",
                            height: "36px",
                            textAlign: "center",
                            lineHeight: "35px",
                            borderRadius: "4px",
                            background: "white",
                            fontSize: 14,
                          }}
                          className="btn    waves-effect waves-light w-auto chatclose-no volte-text "
                          onClick={() => {
                            setShowClose(false);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary waves-effect waves-light w-auto chatclose-yes volte-text "
                          style={{
                            cursor: "pointer",
                            height: "36px",
                            lineHeight: "35px",
                            borderRadius: "4px",
                            fontSize: 14,
                          }}
                          type="button"
                          onClick={() => {
                            handleConfirm();
                          }}
                        >
                          Confirm
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {showClearChat && (
              <>
                <div
                  className="clear-chat-blkoverlay"
                  style={{ display: "block" }}
                >
                  <div
                    className="clearChat"
                    style={{ zIndex: 999999999999999 }}
                  >
                    <p style={{ margin: 0, fontSize: "14px" }}>
                      {" "}
                      Are you sure you want to clear the chat?
                    </p>
                    <div className="btn-contr mT20">
                      <button
                        className="btn btn-primary waves-effect waves-light w-auto chatclose-yes"
                        style={{
                          cursor: "pointer",
                          height: "36px",
                          lineHeight: "35px",
                          borderRadius: "23px",
                          minWidth: "40px",
                          padding: "0px",
                        }}
                        onClick={() => clearChat()}
                      >
                        Yes
                      </button>
                      <button
                        style={{
                          border: "1px solid #E1009D",
                          cursor: "pointer",
                          height: "36px",
                          textAlign: "center",
                          lineHeight: "35px",
                          borderRadius: "23px",
                          background: "white",
                          minWidth: "40px",
                          padding: "0px",
                        }}
                        className="btn    waves-effect waves-light w-auto chatclose-no "
                        onClick={() => {
                          setIsClearChatModal(false);
                        }}
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* Full-Screen Image Modal */}
            
          
            {showFeedback && litmusFeedback && (
  <div
    style={{
      position: "fixed",
      left: 0,
      top: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 99999999,
      animation: "fadeInZoom 0.2s ease-out",
    }}
  >
    {/* Close button */}
    <div style={{ position: "absolute", top: 20, right: 20, zIndex: 100000000 }}>
      <button
        onClick={() => {
          window.top.postMessage({ endChatURLFeedback: "true" }, "*");
          setTimeout(() => {
            setShowFeedback(false);
            setLitmusFeedback(null);
          }, 100);
        }}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          color: "black",
          fontSize: "24px",
        }}
      >
        <X size={28} />
      </button>
    </div>

    <iframe
      src={litmusFeedback}
      title="Embedded Page"
      width="100%"
      height="100%"
      style={{
        border: "none",
        borderRadius: "8px",
        zIndex: 99999999,
      }}
      allowFullScreen
    />
  </div>
)}

           <div
        style={{
          display: showIframe ? "flex" : "none",
          position: "fixed",
          left: 0,
          top: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 99999999,
          animation: "fadeInZoom 0.2s ease-out",
        }}
      >
      
        <iframe
          ref={iframeRef}
          title="Embedded Chat"
          width="100%"
          height="100%"
          style={{ border: "none", borderRadius: "8px" }}
          allowFullScreen

        />
      </div>
           

         


            {isFullScreen?.show && (
                <div
                  style={{
                    position: "fixed",
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 99999999,
                    animation: "fadeInZoom 0.2s ease-out",
                  }}
                >
                  {/* Close Button */}
                  <button
                    onClick={() =>
                      setIsFullScreen((prevState) => ({ ...prevState, show: false }))
                    }
                    style={{
                      position: "absolute",
                      top: "20px",
                      right: "20px",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "white",
                      fontSize: "24px",
                    }}
                  >
                    <X size={28} />
                  </button>

                  {/* Full-Screen Image */}
                  <img
                    src={isFullScreen?.src}
                    alt="fullscreen"
                    style={{
                      maxWidth: "90%",
                      maxHeight: "90%",
                      cursor: "pointer",
                      animation: "fadeInZoom 0.3s ease-out",
                    }}
                  />
                </div>
              )}


            {!agentHeader ? (
              <div
                id="help-card-header"
                className="help-card-header left-gradient"
                style={{ height: "70px" }}
              >
                <span
                  className="chat-avtar"
                  onClick={() => {
                    setShowVersion(true);
                    setTimeout(() => {
                      setShowVersion(false);
                    }, 2000);
                  }}
                >
                  <img
                    style={{ height: "40px" }}
                    src="https://help.tataplay.com/uploads/templateimages/logo.c1bb6180.png"
                    alt=""
                  />
                </span>

                <img
                  // src="data:image/png;base64,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"
                  src={BuddyIcon}
                  alt="Buddy"
                  style={{ paddingLeft: "10px" , width : '100px', height : '40px' }}
                ></img>
                <span
                  className={
                    showOnlineUI
                      ? "connecting-label"
                      : !isOnline
                      ? "offline-label"
                      : "online-label"
                  }
                ></span>
                <span className="online-text">
                  {showOnlineUI
                    ? "connecting..."
                    : !isOnline
                    ? "offline"
                    : "online"}
                </span>
                <i
                  className="icon-minus-1 mR10"
                  style={{ cursor: "pointer" }}
                  key="miniMizeButtonS360Chart"
                  onClick={() => {
                    if (
                      props.launchOnButton === undefined ||
                      !props.launchOnButton ||
                      props.openChat
                    ) {
                      window.parent.postMessage(
                        {
                          chatMinimized: "true",
                        },
                        "*" //or "www.parentpage.com"
                      );
                    }
                    localStorage.setItem("jumpNode", true);
                    setMaximized(false);
                    setShowMinimize(true);
                    setShowChatToolTip(true);
                    sendOnAppClose();
                    setshowOverlay(false);
                    setTextMessage({
                      key1: "",
                      count: Math.random(0, 1),
                      dontSend: true,
                    });
                    if (
                      props.launchOnButton &&
                      (props.openChat === undefined || props.openChat === null)
                    )
                      minimizeChat();
                  }}
                ></i>
                <i className="icon-close-1" style={{ cursor: "pointer" }}></i>
                <div className="end-chat">
                <div className="header-language-wrap" ref={languageMenuRef}>
                    <button
                      type="button"
                      aria-label="Select language"
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        const rect =
                          e.currentTarget.getBoundingClientRect();
                        setDropdownPos({
                          top: rect.bottom + 6,
                          right: Math.max(
                            8,
                            window.innerWidth - rect.right
                          ),
                        });
                        setShowLanguageDropdown((prev) => !prev);
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer" }}>
                        <img
                          src={languageIcon}
                          alt="Language"
                          style={{ width: "24px", height: "24px" }}
                        />
                        <div className="header-text">Language</div>
                      </div>
                    </button>
                    {showLanguageDropdown && (
                      <ul
                        className="header-language-menu"
                        style={{
                          top: dropdownPos.top,
                          right: dropdownPos.right,
                        }}
                      >
                        {LANGUAGES.filter(
                          (lang) => lang !== (selectedLanguage || "English")
                        ).map((lang) => (
                          <li
                            key={lang}
                            className="header-language-item"
                            onClick={() => {
                              setSelectedLanguage(lang);
                              localStorage.setItem("selectedLanguage", lang);
                              setShowLanguageDropdown(false);
                            }}
                          >
                            {lang}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                <button
                    style={{
                      background: "none",
                      border: "none",
                      opacity: disabledEntryIcons ? 0.5 : 1,
                      pointerEvents: disabledEntryIcons ? "none" : "auto",
                      cursor: disabledEntryIcons ? "not-allowed" : "auto",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer" }}  onClick={() => {
                      setOnMenuButtonClick(true)
                      setCodeValue(null)
                      }}>
                      <img
                        src={menuIcon}
                        alt="Menu"
                        style={{ width: "24px", height: "24px" }}
                      />
                      <div className="header-text">Menu</div>
                    </div>

                  </button>
                  <button
                    style={{
                      background: "none",
                      border: "none",
                      opacity: disabledEntryIcons ? 0.5 : 1,
                      pointerEvents: disabledEntryIcons ? "none" : "auto",
                      cursor: disabledEntryIcons ? "not-allowed" : "auto",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer" , marginLeft : '8px'}} onClick={handleEndChat}>
                      <img
                        src={closeIcon}
                        alt="End Chat"
                        style={{ width: "24px", height: "24px" }}
                      />
                      <div className="header-text">Close</div>
                    </div>

                  </button>
                </div>
              </div>
            ) : (
              <div
                id="help-card-header"
                className="help-card-header left-gradient"
                style={{
                  textAlign: agentHeader ? "left" : "center",
                  height: "70px",
                }}
              >
                <span className="chat-avtar">
                  <img
                    style={{ width: "40px" }}
                    src="https://help.tataplay.com/uploads/templateimages/logo.c1bb6180.png"
                    alt=""
                  />
                </span>
                <div style={{ width: "100%", height: "100%" }}>
                  <div>
                    <span className="chat-avtar-detail bold">
                      {agentInfo.name}
                    </span>
                  </div>

                  <div className="liveAgentSmallHeader">
                    <small>(Live Agent)</small>
                  </div>
                </div>

                <i
                  className="icon-close-1"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setChatData([]);
                    setChatClosed(true);
                    setAgentHeader(false);
                    setShowClose(true);
                    setTextMessage({
                      key1: "",
                      count: Math.random(0, 1),
                      dontSend: true,
                    });
                  }}
                ></i>
              </div>
            )}

            <div
              className={
                agentScreen
                  ? "help-card-body no-scroll my-custom-scrollbar my-custom-scrollbar-primary   "
                  : "help-card-body my-custom-scrollbar my-custom-scrollbar-primary"
              }
              id="s360ChatSectionContainer"
            >
              
              <div className="main-container">
                {showVersion && Constants.env === "UAT" && (
                  <div className="version-notify">{`Version - ${Constants.version}`}</div>
                )}

                <div
                  className="firstblk chat-section"
                  id="section0"
                  ref={myRef}
                >
                  {/* <div className="today-content-wrap">
                    <span className="today-span-tag">Today</span>
                  </div> */}
                  {conversation && (
                    <Conversation
                      setUserDataForAgent={setUserDataForAgent}
                      disconnectInA80={onClickYes}
                      setAgentScreenFunction={setAgentScreenFunction}
                      setInteractionIdFunction={setInteractionIdFunction}
                      currentData={currentData}
                      chatData={chatData}
                      setLoginFromProps={(data) => setLogin(data)}
                      actionConfig={actionFromConfig}
                      thirdOkay={thirdOkay}
                      handleThirdOkay={handleThirdOkay}
                      {...props}
                      historyData={historyData}
                      setLoginLoader={setLoginLoader}
                      setLogin={setLogin}
                      setHistoryData={setHistoryData}
                      sth={sth}
                      showHistory={showHistory}
                      historyLoader={historyLoader}
                      loginLoader={loginLoader}
                      name={name}
                      login={login}
                      auth={auth}
                      setAuth={setAuth}
                      textMessage={textMessage}
                      handleInputBox={handleInputBox}
                      handleDontSend={() =>
                        setTextMessage({
                          key1: "",
                          count: Math.random(0, 1),
                          dontSend: true,
                        })
                      }
                      outSideLink={outSideLink}
                      tempLinkDetails={tempLinkDetails}
                      chatClosed={chatClosed}
                      userClickedOnYes={onClickYes}
                      mergeUI={mergeUI}
                      setHideFooter={setHideFooter}
                      isSessionExpired={isSessionExpired}
                      setIsSessionExpired={setIsSessionExpired}
                      setShowIdlePopup={setShowIdlePopup}
                      isChatWithUs={isChatWithUs}
                      setIsChatWithUs={setIsChatWithUs}
                      setMergeUI={setMergeUI}
                      setDelayBotResponse={setDelayBotResponse}
                      setIsClearChatModal={setIsClearChatModal}
                      setDisabledEntryIcons={setDisabledEntryIcons}
                      onMenuButtonClick={onMenuButtonClick}
                      setOnMenuButtonClick={setOnMenuButtonClick}
                      setIsFullScreen={setIsFullScreen}
                      setShowErrorPopUp={setShowErrorPopUp}
                      showErrorPopUp={showErrorPopUp}
                      setEnableAttachment={setEnableAttachment}
                      attachementImg={attachementImg}
                      uploadRef={uploadRef}
                      isAttachementDisable={isAttachementDisable}
                      setAttachementImg={setAttachementImg}
                      flow = {flow}
                      setFlow={setFlow}
                      setCodeValue={setCodeValue}
                      codeValue={codeValue}
                      validationType={validationType}
                      setValidationType={setValidationType}
                      setGenesisUrl={setGenesisUrl}
                      setShowIframe={setShowIframe}
                      iframeRef={iframeRef}
                      setLitmusFeedback={setLitmusFeedback}
                      litmusFeedback={litmusFeedback}
                      delayTime={delayTime}
                      setDelayTime={setDelayTime}
                      showIdleMsg={showIdleMsg}
                      setShowIdleMsg={setShowIdleMsg}
                      CTAView={CTAView}
                      setCTAView={setCTAView}
                      sessionHistory={sessionHistory}
                      setSessionHistory={setSessionHistory}
                      userDetails={props.userDetails}
                      setEnableA14sValidation={setEnableA14sValidation}
                      
                    />
                  )}
                </div>
              </div>

              {showIdlePopup && !isChatWithUs && (
                <div className="idle-msg-container">
                  <p className="idle-msg-container-content">
                    <span className="volte-text" style={{ fontWeight: "bold" }}>
                      Since it's been a while and there is no revert from you
                      yet, we'll have to close the chat window. But drop by
                      again anytime in case you start missing us. We loved
                      hearing from you. Have a great day!
                    </span>
                    <span
                      style={{
                        fontWeight: "bold",
                        display: "block",
                        marginTop: 10,
                        fontSize: 18,
                      }}
                      className="volte-text"
                    >
                      Please click on Close.
                    </span>
                  </p>
                </div>
              )}
             {showErrorPopUp && (
                <div className="error-popup">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      style={{ marginLeft: 8 }}
                      src={AlertIcon}
                      alt="alertIcon"
                    />
                    <span style={{ marginLeft: 8 }}>
                      Upload unsuccessful: only jpg, jpeg, and png files with a max size of 500kb allowed
                    </span>
                    <X
                      size={18}
                      style={{ cursor: "pointer", marginLeft: "auto" }}
                      onClick={() => setShowErrorPopUp(false)}
                    />
                  </div>
                </div>
              )}
             {showValidationPopup && validationError && (
                <div className="validation-popup-modern">
                  <div className="validation-popup-content">
                    <img
                      style={{ marginLeft: 8 }}
                      src={AlertIcon}
                      alt="alertIcon"
                    />
                    <span className="validation-message">{validationError}</span>
                    <button 
                      className="validation-close"
                      onClick={() => setShowValidationPopup(false)}
                    >
                      <X size={16} />
                    </button>
                  </div>
                </div>
              )}
            </div>

            {toast && (
              <ToastMessage
                message="Please enter appropriate text."
                clickedOnToast={() => setToast(false)}
              />
            )}
            {enableDefaultTextBox && !agentScreen && (
              <div className="text-area-input-box-container">
                <textarea
                  id="tx"
                  maxRows={4}
                  style={{
                    maxHeight: "128px",
                    // opacity: enableDefaultTextBox ? "100%" : "50%",
                  }}
                  ref={messageRef}
                  className="text-area-input-box"
                  aria-label="empty textarea"
                  placeholder="Type your query..."
                  onChange={(e) => handleChange(e)}
                  onKeyDown={handleKeyPress}
                />
                {getValidationType() === 'number' && sessionStorage.getItem('showNumberHint') === 'true' && (
                  <div style={{
                    position: 'absolute',
                    bottom: '60px',
                    left: '20px',
                    background: 'linear-gradient(294.99deg, #A22736 0%, #220046 100%)',
                    color: 'white',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontFamily: '"VoltePlay-Medium", sans-serif',
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
                    zIndex: 1000,
                    animation: 'slideUp 0.3s ease-out'
                  }}>
                    Please enter 10 digit number
                  </div>
                )}
              </div>
            )}
            <>
              {delayBotResponse && (
                <div style={{ textAlign: "start" }}>
                  <div class="spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                  </div>
                </div>
              )}
              <div className="conversation-footer">
                {/* <animated.div
                    onClick={handleClearModal}
                    style={{
                      ...styles,
                      position: "absolute",
                      zIndex: 3,
                      width: "100%",
                      height: "100%",
                      right: "60px",
                      top: "60px",
                      background: "rgba(0, 0, 0, 0.3)",
                    }}
                  >
                    {isClearChatModal && (
                      <div className="clear-chat-animation">
                        <div className="poweredBy-content">
                          <span style={{ fontSize: 10, color: "#abaeb2" }}>
                            Powered by
                          </span>
                          <a
                            href="https://www.oriserve.com/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              style={{ marginLeft: 8 }}
                              src={OriChat}
                              alt="ori"
                            ></img>
                          </a>
                        </div>
                        <div
                          className="clear-transition"
                          onClick={() => {
                            setClicked(false);
                            setIsClearChatModal(true);
                          }}
                        >
                          <MenuIcon style={{ cursor: "pointer", width: 12 }} />
                          <span
                            style={{
                              fontSize: 14,
                              color: "#abaeb2",
                              marginLeft: 8,
                            }}
                          >
                            Clear chat
                          </span>
                        </div>
                      </div>
                    )}
                  </animated.div> */}
                {/* <button
                  style={{
                    background: "none",
                    border: "none",
                    opacity: disabledEntryIcons ? 0.5 : 1,
                    pointerEvents: disabledEntryIcons ? "none" : "auto",
                    cursor: disabledEntryIcons ? "not-allowed" : "auto",
                  }}
                  disabled={disabledEntryIcons}
                >
                  <MenuIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => handleClearModal()}
                  />
                </button> */}

                {/* <textarea
                      id="tx"
                      maxRows={4}
                      style={{
                        maxHeight: "128px",
                        opacity: enableDefaultTextBox ? "100%" : "50%",
                      }}
                      ref={messageRef}
                      className="text-area-input-box"
                      aria-label="empty textarea"
                      placeholder="Type your query..."
                      onChange={(e) => handleChange(e)}
                      onKeyDown={handleKeyPress}
                      // disabled={!enableDefaultTextBox}
                    /> */}
                {hideFooter ? (
                  <p className="volte-text" style={{ cursor: "not-allowed", marginLeft: 20 ,color :'rgba(2, 0, 5, 1)' }}>
                    Please choose any option to proceed
                  </p>
                ) : (
                  <>
                    <textarea
                      id="tx"
                      maxRows={4}
                      style={{
                        maxHeight: "128px",
                        border: validationError ? "2px solid red" : "",
                      }}
                      ref={messageRef}
                      className={validationError ? "text-area-input-box shake" : "text-area-input-box"}
                      aria-label="empty textarea"
                      placeholder="Type your query..."
                      onChange={(e) => handleChange(e)}
                      onKeyDown={handleKeyPress}
                    />
                    {getValidationType() === 'number' && sessionStorage.getItem('showNumberHint') === 'true' && (
                      <div style={{
                        position: 'absolute',
                        bottom: '60px',
                        left: '20px',
                        background: 'linear-gradient(294.99deg, #A22736 0%, #220046 100%)',
                        color: 'white',
                        padding: '8px 12px',
                        borderRadius: '6px',
                        fontSize: '12px',
                        fontFamily: '"VoltePlay-Medium", sans-serif',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
                        zIndex: 1000,
                        animation: 'slideUp 0.3s ease-out'
                      }}>
                        Please enter 10 digit number
                      </div>
                    )}
                    {/* {typedFlag.length > 0 && (
                      <img
                        style={{ cursor: "pointer" }}
                        src={sendIconGrey}
                        alt={sendIcon}
                        height="20px"
                        width="20px"
                        onClick={() => onMessageSend()}
                      />
                    )} */}
                   
                   <button
                    style={{
                      background: "none",
                      border: "none",
                      opacity: !enableAttachment  ? 0.5 : 1,
                      pointerEvents: !enableAttachment  ? "none" : "auto",
                      cursor: !enableAttachment ? "not-allowed" : "pointer",
                    }}
                    disabled={disabledEntryIcons}
                    onClick={() => uploadRef.current?.triggerFileInput()} // If needed
                  >
                    <img
                      src={attachementImg} 
                      alt="Attachment Icon"
                      style={{
                        width: '23px',
                        height: '23px' , //attachementImg ===  isBlinkAttachement ? '60px' : '23px',
                        cursor: !enableAttachment ? "not-allowed" : "pointer",
                        // left : attachementImg ===  isBlinkAttachement && '6px',
                        position : 'relative'
                      }}
                      className={blinking ? "blink" : ""}
                    />
                  </button>
                  <button
                    style={{
                      background: "none",
                      border: "none",
                      opacity: disabledEntryIcons || validationError ? 0.5 : 1,
                      pointerEvents: disabledEntryIcons || validationError ? "none" : "auto",
                      cursor: disabledEntryIcons || validationError ? "not-allowed" : "pointer",
                    }}
                    disabled={disabledEntryIcons || validationError}
                    onClick={() => onMessageSend()}
                  >
                    <img
                      src={sendButton} 
                      alt="sendButton Icon"
                      style={{
                        cursor: disabledEntryIcons || validationError ? "not-allowed" : "pointer",
                      }}
                    />
                  </button>

                  </>
                )}
              </div>
            </>
          </div>
        )}
      </>
    </Fragment>
  );
};

export default HelpAssistant;
